export default "__VITE_ASSET__38242094__"